module.exports = __webpack_public_path__ + "img/genicon-candidate-unknown.f2a84d13.svg";